import { tafRequest } from 'amkit3-modules/utils/taf'
import GetVideoListByVids from 'amkit3-modules/utils/taf/jce/GetVideoListByVids'

export const getVideoListByVids = data =>
  tafRequest({
    data: {
      ...data,
      isNeedStreamUrl: false,
      isNeedDanmuNum: false,
      isNeedCommentNum: false,
    },
    funcName: 'getVideoListByVids',
    reqClass: GetVideoListByVids.VideoQueryByIdReq,
    rspClass: GetVideoListByVids.VideoListRsp,
  })
